import { useTranslation } from 'react-i18next';
import { gql } from '@apollo/client';
import {
  MetricSumClosedContactsWhereInput,
  Query,
} from '@lgg/isomorphic/types/__generated__/graphql';
import {
  CardMainNumericValue,
  GenericSmallCard,
} from 'src/components/pages/dashboard/components/shared';

export const GET_METRIC_CLOSED_CONTACTS_QUERY = gql`
  query GetMetricSumClosedContacts(
    $institutionId: Int!
    $period: MetricPeriodWhereInput!
    $comparePeriod: MetricComparePeriodInput
    $where: MetricSumClosedContactsWhereInput
  ) {
    metricSumClosedContacts(
      institutionId: $institutionId
      period: $period
      comparePeriod: $comparePeriod
      where: $where
    ) {
      total
      previousPeriod {
        total
        trendChangePercentage
        trendChangeIndicator
      }
      lastUpdatedAt
    }
  }
`;

export const ClosedContactsCard = () => {
  const { t } = useTranslation(['dashboard']);

  return (
    <GenericSmallCard<
      Pick<Query, 'metricSumClosedContacts'>,
      MetricSumClosedContactsWhereInput
    >
      title={t('dashboard:cards.closedContacts.title')}
      query={GET_METRIC_CLOSED_CONTACTS_QUERY}
      dataResolver={(result) => {
        const metricData = result.data?.metricSumClosedContacts;

        if (!metricData) {
          return undefined;
        }

        const { lastUpdatedAt, total = null, previousPeriod } = metricData;

        return {
          lastUpdatedAt,
          total,
          previousPeriod: previousPeriod
            ? {
                trendChangePercentage: previousPeriod?.trendChangePercentage,
                trendChangeIndicator: previousPeriod?.trendChangeIndicator,
                total: previousPeriod?.total ?? 0,
              }
            : null,
        };
      }}
      whereResolver={({ targetUserId }) => ({
        dimensionContactAssignee: { id: { _eq: targetUserId } },
      })}
      valueTransformer={(value = null) => <CardMainNumericValue value={value} />}
      cardInfoI18nKey="dashboard:cards.closedContacts.tooltipDescription"
      testId="dashboard-closed-contacts-card"
    />
  );
};
